module.exports = __webpack_public_path__ + "img/roulette.e4666bcc.png";